<template>
    <div id="text">
        <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed&amp;display=swap" rel="stylesheet">
        <div id="text-wrapper">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:"TextSection",
}
</script>

<style scoped>
    #text{
        color: #F0F0F0;
        font-family: 'Roboto', sans-serif;
        line-height: 1.5;
        font-weight: lighter    
    }
    #text-wrapper{
        margin: auto;
        width: 70%;
        min-width: 30rem;
    }
    @media only screen and (max-width: 600px) {
    #text-wrapper{
        margin: None;
        width: auto;
        padding: 1rem;
        min-width: 0px;
    }
    }
    hr{
        margin: none;
        border-top: none;
        border-color: #F0F0F0;
    }
</style>